export function generateNSizeArray(length: number, fillWith = undefined) {
  if (length <= 0) return []

  return Array.from({ length }, (_, i) => fillWith ?? i)
}
